/**
 * @generated SignedSource<<39e68d765037411ff1c6f2df189aaab2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AdminUserInfoAdminApplyStreakFreezeMutation$variables = {
  userId: string;
  when: string;
};
export type AdminUserInfoAdminApplyStreakFreezeMutation$data = {
  readonly adminApplyStreakFreeze: {
    readonly xps: {
      readonly currentStreak: number;
      readonly days: ReadonlyArray<{
        readonly added: number | null;
        readonly freeze: string | null;
        readonly reviewed: number | null;
        readonly streaked: boolean;
        readonly when: string;
        readonly xp: number | null;
      }>;
      readonly total: number;
    };
  };
};
export type AdminUserInfoAdminApplyStreakFreezeMutation = {
  response: AdminUserInfoAdminApplyStreakFreezeMutation$data;
  variables: AdminUserInfoAdminApplyStreakFreezeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "when"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  },
  {
    "kind": "Variable",
    "name": "when",
    "variableName": "when"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Xps",
  "kind": "LinkedField",
  "name": "xps",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentStreak",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DayXps",
      "kind": "LinkedField",
      "name": "days",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "xp",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "added",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reviewed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "when",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streaked",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "freeze",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminUserInfoAdminApplyStreakFreezeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "adminApplyStreakFreeze",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminUserInfoAdminApplyStreakFreezeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "adminApplyStreakFreeze",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9fe49f925aab8bd11e7a8b697703a43",
    "id": null,
    "metadata": {},
    "name": "AdminUserInfoAdminApplyStreakFreezeMutation",
    "operationKind": "mutation",
    "text": "mutation AdminUserInfoAdminApplyStreakFreezeMutation(\n  $userId: ID!\n  $when: String!\n) {\n  adminApplyStreakFreeze(userId: $userId, when: $when) {\n    xps {\n      total\n      currentStreak\n      days {\n        xp\n        added\n        reviewed\n        when\n        streaked\n        freeze\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "2b4c3f5d5d7519ca6f5a21d7a4103209";

export default node;
